import { createClient, type SupabaseClient } from '@supabase/supabase-js';

export type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Creates a Supabase client from the given URL and anon key.
 * Called once in main.ts — the result is injected into modules that need it.
 */
export function createSupabaseClient(
  url: string,
  anonKey: string,
): SupabaseClient {
  return createClient(url, anonKey);
}
